import React, { useRef, useState } from "react";
import "../styles.css";
//internal and external componentscontainers
import {
  Typography,
  Paper,
  Box,
  Fade,
  Popper,
  ClickAwayListener,
  Button,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Textarea from "@mui/joy/Textarea";
import { CssVarsProvider as JoyCssVarsProvider } from "@mui/joy/styles";
import ActionsTable from "../../../components/ActionsTable";
import { AvatarAndName } from "../../../components/AvatarAndName";
import { colors } from "../../../common/pallette/colors";
import {
  getEvaluationReportStandardDetails,
  getOffSiteEvaluationByStandard,
  getStandardsEvidences,
  getStandardsSelfAssessmentComment,
  getStandrdsActions,
  saveEvaluationReportStandardDetails,
} from "../../../api/evaluation";
import { useDispatch, useSelector } from "react-redux";
import {
  setActionsList,
  setOffSiteEvaluation,
  setProjectList,
  setSaActions,
  setSaComments,
  setSaEvidences,
  setSelectedOffSiteStandard,
  setStaffList,
  setStandardStatuses,
} from "../../../redux/reducers/evaluation";
import { getAllActions, updateActions } from "../../../api/action";
import { getStaff } from "../../../api/user";
import { getProjectsByClub } from "../../../api/club";
import { evidenceToStandard, uploadFile } from "../../../api/evidence";
import { formatDateTime, genUID } from "../../../common/StaticExports";
import EvidencesTable from "../../../components/EvidencesTable";
import SplitButton from "../../../components/SplitButton";
import EvidencePopup from "../../../components/EvidencePopup";
import { baseUrl } from "../../../api/config";
import { useTranslation } from "react-i18next";
import { color } from "html2canvas/dist/types/css/types/color";
import SelectBoxPrimary from "../../../components/SelectBoxPrimary";
import { SwitchButton } from "../../../components/SwitchButton";
import { getStandardIsComplete } from "../../../api/standards";
import { setSnackBarData } from "../../../redux/reducers/common";
import { Navigators } from "../../../components/Navigators";

const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: 50,
        },
      },
    },
  },
});

const OffSiteStandardsDetail = (props: any) => {
  const { isOpen, handleClose } = props;
  const currentClub = useSelector((state: any) => state.clubDetails);
  const [addAction, setAddAction] = React.useState(false);
  const [addEvidence, setAddEvidence] = React.useState(false);
  const [isOpenLibModal, setIsOpenLibModal] = React.useState(false);
  const actions = useSelector((state: any) => state.evaluation.saActions);
  const evidences = useSelector((state: any) => state.evaluation.saEvidences);
  const selfAssessmentComment = useSelector(
    (state: any) => state.evaluation.saComments
  );
  const offSiteEvaluation = useSelector(
    (state: any) => state.evaluation.offSiteEvaluation
  );
  const [isLoadingActions, setIsLoadingActions] = useState(false);
  const [isLoadingEvidences, setIsLoadingEvidences] = useState(false);
  const [isAddAcionLoad, setIsAddAcionLoad] = useState(false);
  const [isFetchingStatus, setIsFetchingStatus] = useState(false);
  const isAdmin = useSelector((state: any) => state.common.isAdmin);
  const standardStatuses = useSelector(
    (state: any) => state.evaluation.standardStatuses
  );
  const selctedOffSiteStandard = useSelector(
    (state: any) => state.evaluation.selctedOffSiteStandard
  );
  const dispatch = useDispatch();
  const fileInputRef: any = useRef(null);
  const [t] = useTranslation();
  const [isEdited, setIsEdited] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded((prev) => !prev);
  const standardIds = useSelector((state:any) => state.evaluation.offSiteStandards?.map((standard:any) => standard.id));
  const standards = useSelector((state:any) => state.evaluation.offSiteStandards);
  const maxLength = 150;
  const shouldTruncate =
    selctedOffSiteStandard?.description && selctedOffSiteStandard?.description?.length > maxLength;
  const descriptionText =
    !expanded && shouldTruncate
      ? selctedOffSiteStandard?.description.slice(0, maxLength) + "..."
      : selctedOffSiteStandard?.description;

  const tableHead = [
    {
      key: "",
      displayName: "",
    },
    {
      key: "status",
      displayName: "status",
    },
    {
      key: "actionComment",
      displayName: "action",
    },
    {
      key: "description",
      displayName: "description",
    },
    {
      key: "dueDate",
      displayName: "due date",
    },
    {
      key: "owner",
      displayName: "owner",
    },
    {
      key: "",
      displayName: "",
    },
  ];

  const fetchActions = async () => {
    setIsLoadingActions(true);
    const response = await getStandrdsActions({
      standardId: selctedOffSiteStandard?.id,
      clubId: currentClub.id,
    });
    let evalResponse = await getEvaluationReportStandardDetails({
      standardId: selctedOffSiteStandard?.id,
      clubId: currentClub.id,
    });
    evalResponse = evalResponse?.actions?.map((d: any) => {
      return { ...d, isCreatedByJL: true, ragb: 4 };
    });
    const tempResponse: any = [...evalResponse, ...response];
    return tempResponse;
  };

  const fetchEvidences = async () => {
    setIsLoadingEvidences(true);
    const response = await getStandardsEvidences({
      standardId: selctedOffSiteStandard?.id,
      clubId: currentClub.id,
    });
    return response;
  };

  const fetchSelfAssessmentComments = async () => {
    const response = await getStandardsSelfAssessmentComment({
      standardId: selctedOffSiteStandard?.id,
      clubId: currentClub.id,
    });
    return response;
  };

  const fetchStandardsEvaluation = async () => {
    const response = await getOffSiteEvaluationByStandard({
      standardId: selctedOffSiteStandard?.id,
      clubId: currentClub.id,
    });
    return response;
  };

  const fetchStatuses = async () => {
    setIsFetchingStatus(true);
    const response = await getStandardIsComplete({
      standardId: selctedOffSiteStandard?.id,
      clubId: currentClub.id,
    });
    return response;
  };

  React.useEffect(() => {
    if (isOpen && selctedOffSiteStandard?.id && currentClub?.id) {

      !isLoadingActions &&
      fetchActions().then((res) => {
        dispatch(setSaActions(res));
        setIsLoadingActions(false);
      });

      !isLoadingEvidences &&
      fetchEvidences().then((res) => {
        dispatch(setSaEvidences(res));
        setIsLoadingEvidences(false);
      });

      !selfAssessmentComment &&
      fetchSelfAssessmentComments().then((res) => {
        dispatch(setSaComments(res));
      });

      !offSiteEvaluation &&
      fetchStandardsEvaluation().then((res) => {
        dispatch(setOffSiteEvaluation(res));
      });

      !isFetchingStatus &&
      fetchStatuses().then((res) => {
        dispatch(setStandardStatuses(res));
        setIsFetchingStatus(false);
      });
    }
  }, [isOpen, selctedOffSiteStandard, currentClub]);

  const manageAddAction = () => {
    const fetchActionList = async () => {
      setIsAddAcionLoad(true);
      const response = await getAllActions({
        clubId: currentClub.id,
        isSelfAssessment: true,
      });
      return response;
    };
    const fetchStaffList = async () => {
      const response = await getStaff({ clubId: currentClub.id });
      return response;
    };
    const fetchClubProject = async () => {
      const response = await getProjectsByClub({ clubId: currentClub.id });
      return response;
    };

    if (currentClub?.id) {
      fetchActionList().then((res) => {
        dispatch(setActionsList(res));
      });
      fetchStaffList().then((res) => {
        dispatch(setStaffList(res));
      });
      fetchClubProject().then((res) => {
        dispatch(setProjectList(res));
        setIsAddAcionLoad(false);
      });
    }
    setAddAction(true);
  };

  const handleFileChange = (e: any) => {
    const params: any = {
      clubId: currentClub.id,
      standardId: selctedOffSiteStandard?.id,
      file: e.target.files[0],
      standardKind: 0,
      currentFolderId: 0,
    };

    const fileUpload = async () => {
      const response = await uploadFile(params);
      return response;
    };

    e.target.files[0] &&
      currentClub.id &&
      selctedOffSiteStandard?.id &&
      fileUpload().then((res) => {
        const tempArr: any = [...evidences, res];
        dispatch(setSaEvidences(tempArr));
        setAddEvidence(false);
      });
  };

  const manageEvidenceClick = (label: any) => {
    switch (label) {
      case "Add Evidence":
        fileInputRef.current.click();
        setAddEvidence(true);
        break;
      case "Add Evidence From Library":
        setAddEvidence(true);
        setIsOpenLibModal(true);
        break;
    }
  };

  const linkLibraryFile = (fileData: any) => {
    const linkToStandard = async () => {
      const response = await evidenceToStandard({
        fileId: fileData.id,
        standardId: selctedOffSiteStandard?.id,
      });
      return response;
    };
    linkToStandard().then((res) => {
      const tempArr: any = [...evidences, res];
      dispatch(setSaEvidences(tempArr));
      setAddEvidence(false);
      setIsOpenLibModal(false);
    });
  };

  const handleClickInsidePopper = (event: MouseEvent) => {
    event.stopPropagation();
    // handleIsOpen()
  };

  const manageEvaluationChange = (key: any, updatedValue: any) => {
    const tempData = { ...offSiteEvaluation, [key]: updatedValue };
    dispatch(setOffSiteEvaluation(tempData));
    setIsEdited(true);
  };
  const manageCRUDMethod = async (type: string, dataToUpdate?: any) => {
    switch (type) {
      // CRUD for criteria evaluation actions
      case "create":
        var actionArr: any = [dataToUpdate, ...actions];
        dispatch(setSaActions(actionArr));
        setAddAction(false);
        var parameters = {
          clubId: currentClub?.id,
          standardId: selctedOffSiteStandard?.id,
          actions: actionArr,
        };
        if (dataToUpdate?.isCreatedByJL && isAdmin) {
          saveEvaluationReportStandardDetails(parameters).then((res: any) => {
            const tempArr = actionArr?.filter((d:any) => !d.isCreatedByJL);
            const evalResponse = res?.actions?.map((d: any) => {
              return { ...d, isCreatedByJL: true, ragb: 4 };
            });
            const finalArr:any = [...evalResponse, ...tempArr];
            dispatch(setSaActions(finalArr));
            const warningData: any = {
              isOpen: true,
              severity: "success",
              message: t("ACTION_CREATED_SUCCESSFULLY"),
            };
            dispatch(setSnackBarData(warningData));
          });
        } else {
          await updateActions(parameters).then((res: any) => {
            dispatch(setSaActions(res));
            const warningData: any = {
              isOpen: true,
              severity: "success",
              message: t("ACTION_CREATED_SUCCESSFULLY"),
            };
            dispatch(setSnackBarData(warningData));
          });
        }
        break;

      case `delete`:
        var itemToDelete = actions?.find((d:any) => d?.id == dataToUpdate);
        var tempArrDelete = actions.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        dispatch(setSaActions(tempArrDelete));
        if (itemToDelete?.isCreatedByJL && isAdmin) {
            var paramsToDelte = {
              clubId: currentClub?.id,
              standardId: selctedOffSiteStandard?.id,
              actions: tempArrDelete,
            };
          saveEvaluationReportStandardDetails(paramsToDelte).then((res: any) => {
            const tempArr = tempArrDelete?.filter((d:any) => !d.isCreatedByJL);
            const evalResponse = res?.actions?.map((d: any) => {
              return { ...d, isCreatedByJL: true, ragb: 4 };
            });
            const finalArr:any = [...evalResponse, ...tempArr];
            dispatch(setSaActions(finalArr));
            const warningData: any = {
              isOpen: true,
              severity: "success",
              message: t("ACTION_DELETED_SUCCESSFULLY"),
            };
            dispatch(setSnackBarData(warningData));
          });
        }
        break;

      case `archive`:
        var tempArrArchive = actions.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        dispatch(setSaActions(tempArrArchive));
        break;

      case `update`:
        if (dataToUpdate?.isCreatedByJL && isAdmin) {
          var actionArrEval: any = [dataToUpdate, ...actions];
          dispatch(setSaActions(actionArrEval));
          setAddAction(false);
          var params = {
            clubId: currentClub?.id,
            standardId: selctedOffSiteStandard?.id,
            actions: actionArrEval,
          };
          saveEvaluationReportStandardDetails(params).then((res: any) => {
            const tempArr = actionArrEval?.filter((d:any) => !d.isCreatedByJL);
            const evalResponse = res?.actions?.map((d: any) => {
              return { ...d, isCreatedByJL: true, ragb: 4 };
            });
            const finalArr:any = [...evalResponse, ...tempArr];
            dispatch(setSaActions(finalArr));
            const warningData: any = {
              isOpen: true,
              severity: "success",
              message: t("ACTION_UPDATED_SUCCESSFULLY"),
            };
            dispatch(setSnackBarData(warningData));
          });
        } else {
          var tempArrUpdate = actions.map((actionItem: any) =>
            actionItem.id == dataToUpdate?.id ? dataToUpdate : actionItem
          );
          dispatch(setSaActions(tempArrUpdate))
        };
        break;

      case `unlink`:
        var tempArrUnlink = actions.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        dispatch(setSaActions(tempArrUnlink));
        break;
    }
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Popper className="popperStyle" open={isOpen} transition>
          {({ TransitionProps }) => (
            <ClickAwayListener
              onClickAway={() => {
                handleClose(isEdited);
              }}
            >
              <Fade {...TransitionProps} timeout={350}>
                <Paper
                  sx={{
                    p: 2,
                    width: "1200px",
                    height: "90vh",
                    overflowY: "auto",
                    margin: "auto",
                    mt: "3vh",
                  }}
                  onClick={() => handleClickInsidePopper}
                >
                  <Box className={"standardDetailsHeader"}>
                    <Box className={"detailsWrapper"} sx={{ mt: 0 }}>
                      <Typography className="fs13 fw700">
                        {genUID(selctedOffSiteStandard?.uid) + " " + selctedOffSiteStandard?.name}
                      </Typography>
                      <Typography className="fs13">
                        {descriptionText}
                        <Typography
                          className="fs13 displayinlineBlock"
                          onClick={toggleExpanded}
                        >
                          {descriptionText?.length < maxLength
                            ? ""
                            : expanded
                              ? "(Show less)"
                              : "(Show more)"}
                        </Typography>
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center" }}>
                      <Navigators 
                      navigatorIds={standardIds} 
                      navigatorData={standards} 
                      manageStateChange={(tempData:any) => {dispatch(setSelectedOffSiteStandard(tempData))}} />
                      <SelectBoxPrimary
                        label={""}
                        report={"siteReview"}
                        options={[0, 1, 2, 3]}
                        isStatus={true}
                        manageChange={(e: any) => {
                          manageEvaluationChange("status", e);
                        }}
                        selected={offSiteEvaluation?.status || 0}
                      />
                    </Box>
                  </Box>
                  <Box className={"standardDetailsContainer"}>
                    <Box className={"detailsWrapper"}>
                      <Typography className="standardsHeading uppercase">
                        Actions
                      </Typography>
                      <Button
                        className={true ? "smallButton" : "displayNone"}
                        sx={{ float: "right" }}
                        disableElevation
                        onClick={() => {
                          manageAddAction();
                        }}
                        variant="contained"
                        size="small"
                        startIcon={
                          <FontAwesomeIcon className="fs13" icon={faPlus} />
                        }
                        disabled={addAction}
                      >
                        {"Add Action"}
                      </Button>
                      <Box sx={{ mt: 6 }}>
                        <ActionsTable
                          data={actions}
                          head={tableHead}
                          currentStandard={selctedOffSiteStandard}
                          isAction={false}
                          addAction={addAction}
                          isLoading={isLoadingActions}
                          isAddLoading={isAddAcionLoad}
                          bg={"#FAFAFA"}
                          handleClick={() => setAddAction(false)}
                          manageCRUD={manageCRUDMethod}
                          module={t("EVALUATION")}
                        />
                      </Box>
                    </Box>
                    <Box className={"detailsWrapper"}>
                      <Typography className="standardsHeading uppercase">
                        Evidence
                      </Typography>
                      <EvidencePopup
                        isOpen={isOpenLibModal}
                        manageFileSelect={(d: any) => {
                          linkLibraryFile(d);
                        }}
                        manageClickAway={() => {
                          setIsOpenLibModal(false);
                        }}
                      />
                      {false && (
                        <>
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                          <Box sx={{ float: "right" }}>
                            <SplitButton
                              options={[
                                "Add Evidence",
                                "Add Evidence From Library",
                              ]}
                              handleClick={(e: any) => {
                                manageEvidenceClick(e);
                              }}
                            />
                          </Box>
                          {/* <Button className='smallButton' sx={{ float: 'right' }} disableElevation 
                                            onClick={() => {fileInputRef.current.click(); setAddEvidence(true);}} variant='contained' size='small' startIcon={<FontAwesomeIcon icon={faPlus} />} disabled={addEvidence}>
                                                {'Add Evidence'}
                                            </Button> */}
                          {/* <Button className='smallButton mr10' sx={{ float: 'right' }} 
                                            disableElevation 
                                            onClick={() => setAddEvidence(true)} 
                                            variant='contained' size='small' 
                                            startIcon={<FontAwesomeIcon icon={faPlus} />} disabled={addEvidence}>
                                                {'Add Evidence From Library'}
                                            </Button> */}
                        </>
                      )}
                      <Box sx={{ mt: 1 }}>
                        <EvidencesTable
                          data={evidences}
                          isLoading={isLoadingEvidences}
                          bg={"#FAFAFA"}
                        />
                      </Box>
                    </Box>
                    <Box className={"detailsWrapper"}>
                      <Typography className="standardsHeading uppercase">
                        {t("SELF_ASSESSMENT")}
                      </Typography>
                      <Box className={"sdCommentsWrapper"}>
                        <JoyCssVarsProvider>
                          <Textarea
                            sx={{
                              borderRadius: "6px",
                              mt: 0,
                              width: "80%",
                              // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                              "&.Mui-disabled": {
                                "--Textarea-disabledColor": "black",
                                color: "black",
                              },
                            }}
                            disabled={true}
                            placeholder="Add comment"
                            minRows={4}
                            maxRows={4}
                            value={selfAssessmentComment?.comment}
                          />
                        </JoyCssVarsProvider>
                        <Box className={"SDuserDetailsWrapper"}>
                          {selfAssessmentComment?.firstName != null &&
                            selfAssessmentComment?.firstName != "" && (
                              <>
                                <AvatarAndName
                                  avatarName={
                                    selfAssessmentComment?.firstName
                                      ? `${selfAssessmentComment.firstName} ${selfAssessmentComment.lastName}`
                                      : "Undefined"
                                  }
                                  avatarImage={
                                    selfAssessmentComment.avatarPath
                                      ? `${baseUrl}/Content${selfAssessmentComment.avatarPath}`
                                      : ""
                                  }
                                />
                                <Typography
                                  className="fs12"
                                  sx={{ ml: "32px", mb: "10px" }}
                                >
                                  {formatDateTime(
                                    selfAssessmentComment.updatedDate
                                  )}
                                </Typography>
                              </>
                            )}
                        </Box>
                      </Box>
                    </Box>
                    <Box className={"detailsWrapper"}>
                      <Typography className="standardsHeading uppercase">
                        {t("EVALUATION")}
                      </Typography>
                      <Box className={"sdCommentsWrapper"}>
                        <JoyCssVarsProvider>
                          <Textarea
                            sx={{ borderRadius: "6px", mt: 0, width: "80%" }}
                            onChange={(e: any) => {
                              manageEvaluationChange("comment", e.target.value);
                            }}
                            placeholder="Add comment"
                            minRows={4}
                            maxRows={4}
                            value={offSiteEvaluation?.comment}
                          />
                        </JoyCssVarsProvider>
                        <Box className={"SDuserDetailsWrapper"}>
                          {offSiteEvaluation?.firstName != null &&
                            offSiteEvaluation?.firstName != "" && (
                              <>
                                <AvatarAndName
                                  avatarName={
                                    offSiteEvaluation?.firstName
                                      ? `${offSiteEvaluation.firstName} ${offSiteEvaluation.lastName}`
                                      : "Undefined"
                                  }
                                  avatarImage={
                                    offSiteEvaluation.avatarPath
                                      ? `${baseUrl}/Content${offSiteEvaluation.avatarPath}`
                                      : ""
                                  }
                                />
                                <Typography
                                  className="fs12"
                                  sx={{ ml: "32px", mb: "10px" }}
                                >
                                  {formatDateTime(
                                    offSiteEvaluation.updatedDate
                                  )}
                                </Typography>
                              </>
                            )}
                          <SelectBoxPrimary
                            label={""}
                            report={"siteReview"}
                            options={[0, 1, 2, 3]}
                            isStatus={true}
                            manageChange={(e: any) => {
                              manageEvaluationChange("status", e);
                            }}
                            selected={offSiteEvaluation?.status || 0}
                          />
                        </Box>
                      </Box>
                    </Box>
                    <Box className={"detailsWrapper mt20"}>
                      <SwitchButton
                        label={t("IS_COMPLETE") + ": "}
                        isOn={standardStatuses?.isComplete || false}
                        inlineStyle={{
                          color: colors.black.dark,
                          fontWeight: 700,
                        }}
                        disabled={true}
                      />
                    </Box>
                  </Box>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default OffSiteStandardsDetail;
